<!--
 * @Author: csu chen.su@murata.com
 * @Date: 2022-06-22 15:36:48
 * @LastEditors: csu chen.su@murata.com
 * @LastEditTime: 2023-07-19 17:54:54
 * @FilePath: \frontend\src\components\Screenfull\index.vue
-->
<template>
  <div>
    <svg-icon style="color: aliceblue" :icon-class="isFullscreen ? 'exit-fullscreen' : 'fullscreen'" @click="click" />
  </div>
</template>

<script>
import screenfull from 'screenfull';

export default {
  name: 'Screenfull',
  data() {
    return {
      isFullscreen: false,
    };
  },
  mounted() {
    this.init();
  },
  beforeUnmount() {
    this.destroy();
  },
  methods: {
    click() {
      if (!screenfull.isEnabled) {
        this.message({
          message: this.$t('navbar.unableScreenFull'),
          type: 'warning',
        });
        return false;
      }
      screenfull.toggle();
    },
    change() {
      this.isFullscreen = screenfull.isFullscreen;
    },
    init() {
      this.isFullscreen = screenfull.isFullscreen;
      if (screenfull.isEnabled) {
        screenfull.on('change', this.change);
      }
    },
    destroy() {
      if (screenfull.isEnabled) {
        screenfull.off('change', this.change);
      }
    },
  },
};
</script>

<style scoped>
.screenfull-svg {
  display: inline-block;
  cursor: pointer;
  fill: #5a5e66;
  width: 20px;
  height: 20px;
  vertical-align: 10px;
}
</style>
